

import { Component, Vue } from 'vue-property-decorator';
import { namespace } from "vuex-class";
import "@/store/modules/information";
const informationState = namespace("Information");

import "@/store/modules/forms/form22";
const form22State = namespace("Form22");

import { form22DataInfoType, form22SearchInfoType } from '@/types/Information/Form22';
import { initiatingDocumentJsonInfoType, partiesDataJsonDataType, previousCourtJsonInfoType } from '@/types/Information/json';
import Spinner from "@/components/utils/Spinner.vue";

@Component({
    components: {           
        Spinner
    }        
}) 
export default class Form22CaseInformation extends Vue {

    @informationState.Action
    public UpdatePartiesJson!: (newPartiesJson: partiesDataJsonDataType) => void

    @informationState.Action
    public UpdatePreviousCourts!: (newPreviousCourts: previousCourtJsonInfoType[]) => void

    @informationState.Action
    public UpdateInitiatingDocuments!: (newInitiatingDocuments: initiatingDocumentJsonInfoType[]) => void

    @informationState.Action
    public UpdateFileNumber!: (newFileNumber: string) => void
    
    @form22State.Action
    public UpdateCurrentNoFeesPayableId!: (newCurrentNoFeesPayableId: string) => void
    
    @form22State.Action
    public UpdateForm22Info!: (newForm22Info: form22DataInfoType) => void

    @form22State.State
    public form22Info: form22DataInfoType;
    
    levelOfCourt = "Court of Appeal";

    fileNumberState = true;
    partyState = true;
    dataReady = false;
    searching = false;
    caseInfoExists = false;

    searchParams = {} as form22SearchInfoType;
    notFound = false;
    partyOptions = [
        {text: 'Individual', value: 'Individual'},
        {text: 'Organization', value: 'Organization'}
    ];

    yesNoOptions = [
        {text: 'Yes', value: true},
        {text: 'No', value: false}
    ];

    mounted(){
        this.fileNumberState = true;
        this.partyState = true;
        this.dataReady = false;
        this.searching = false;
        this.caseInfoExists = false;
        this.dataReady = true; 
    }

    public navigateToForm22() {

        const form22SubmissionData = {} as form22DataInfoType;
        form22SubmissionData.manualAppellants = [];
        form22SubmissionData.manualRespondents = [];
        form22SubmissionData.appellants = [];
        form22SubmissionData.respondents = [];
        form22SubmissionData.requiresManualEntry = true;       
        this.UpdateForm22Info(form22SubmissionData);
        this.UpdateCurrentNoFeesPayableId(null);
        this.$router.push({name: "fill-form22"})
    }

    public findFile(){

        this.searching = true;        
        this.notFound = false;
        this.fileNumberState = true;
        this.partyState = true;

        if(!this.searchParams.file){
            this.fileNumberState = false;
            this.searching = false;
            return
        }

        if(!this.searchParams.searchBy){
            this.partyState = false;
            this.searching = false;
            return
        }
        
        const url = '/form7s/?'+
            'caseNumber='+(this.searchParams.file?this.searchParams.file:'')+
            '&firstName='+(this.searchParams.firstName?this.searchParams.firstName:'')+
            '&lastName='+(this.searchParams.lastName?this.searchParams.lastName:'')+
            '&searchBy='+(this.searchParams.searchBy?this.searchParams.searchBy:'')+
            '&organizationName='+(this.searchParams.organizationName?this.searchParams.organizationName:''); 
        
        this.$http.get(url)
        .then(res => {
            this.searching = false;
            if(res.data?.parties){
                this.UpdatePartiesJson(res.data.parties);
                this.UpdateFileNumber(this.searchParams.file);
                const form22SubmissionData = {} as form22DataInfoType;        
                form22SubmissionData.requiresManualEntry = false;       
                this.UpdateForm22Info(form22SubmissionData);
                this.UpdateCurrentNoFeesPayableId(null);

                this.$router.push({name: "fill-form22"})
            }

            if (!res.data){
                this.notFound = true;
            }
                
        },err => {
            console.error(err); 
            this.notFound = true;  
            this.searching = false;     
        });
    }

    public coaFileformatter(value){
        if(value.slice(0,2)!='CA'){
            if(isNaN(Number(value.slice(0))))
                return 'CA'
            else
                return 'CA'+value
        }
        if(isNaN(Number(value.slice(-1)))) return value.slice(0,-1)
        return value
    }
}
